(() => {
  const addBusinessDays = (date, days) => {
    const result = new Date(date);
    let remaining = Math.max(0, Number.parseInt(days, 10) || 0);

    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) remaining -= 1;
    }

    return result;
  };

  const hydrateShipDates = (root = document) => {
    root.querySelectorAll('.estimated-ship-date').forEach((element) => {
      const offset = element.dataset.shipOffset;
      if (offset === undefined || element.dataset.shipDateReady === 'true') return;

      const estimatedDate = addBusinessDays(new Date(), offset);
      const formattedDate = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      }).format(estimatedDate);
      const label = element.dataset.shipLabel || 'Estimated ship date (when your order leaves Gigatech)';

      element.textContent = `${label}: ${formattedDate}`;
      element.dataset.shipDateReady = 'true';
    });
  };

  const removeOutdatedShippingBadges = (root = document) => {
    const selector = '.text-block--text_pCqKbC, .text-block--text_zmWFUF';
    const badgeBlocks = [];

    if (root instanceof Element && root.matches(selector)) {
      badgeBlocks.push(root);
    }

    root.querySelectorAll?.(selector).forEach((block) => badgeBlocks.push(block));

    badgeBlocks.forEach((block) => {
      if (block.textContent.toLowerCase().includes('shipping')) {
        block.remove();
      }
    });
  };

  const initialize = () => {
    hydrateShipDates();
    removeOutdatedShippingBadges();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    hydrateShipDates(event.target);
    removeOutdatedShippingBadges(event.target);
  });

  const badgeObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) removeOutdatedShippingBadges(node);
      });
    });
  });

  badgeObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
